<template>
  <v-footer
    app
    :color="bgColor"
    class="d-flex flex-column ga-2 py-4"
  >
    <slot/>
  </v-footer>
</template>

<script lang="ts" setup>
import {onMounted, ref} from 'vue'
import {useApiClient} from "@/composables/useApiClient.ts";

const apiClient = useApiClient();
const props = withDefaults(
  defineProps<{
    variant?: 'white' | 'transparent'
  }>(),
  {
    variant: 'white'
  }
);
const bgColor = ref(props.variant);

onMounted(async () => {
  const { data } = await apiClient.getBrandParameters();
  const background = data?.texts;
  bgColor.value = background && background.homeBackgroundImage ? (background.bgFooter || 'transparent') : props.variant;
});

</script>

<style></style>
